import React from 'react';

const ProductIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width="15"
      height="15"
      fill="gray"
    >
      <path d="M32 4c-1.1 0-2 .9-2 2v12H12c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18v12c0 1.1.9 2 2 2s2-.9 2-2V28h18c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2H34V6c0-1.1-.9-2-2-2zM12 20h40v4H12v-4zm40-6v4H12v-4h40zM32 30h18v4H32v-4z"/>
      <path d="M44 40c-1.1 0-2 .9-2 2v4H22v-4c0-1.1-.9-2-2-2s-2 .9-2 2v6c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2z"/>
      <path d="M24 24l-4-4 4-4v3h8v-6l4 4-4 4v-3h-8v6z" fill="gray"/>
    </svg>
  );
};

export default ProductIcon;
